import React, { useContext } from "react";
import { observer } from "mobx-react";

import { SportOffer } from "@gp/offer";
import OfferIcon from "@components/icons/Offer";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";

export const LiveEventSideMenuSportsList = observer(
	function LiveEventSideMenuSportsList(props: { sportsList: SportOffer[] }) {
		const menuStore = useContext(LiveEventSideMenuContext);

		return (
			<>
				{props.sportsList.map((sport) => (
					<li
						key={sport.id}
						className="nav--secondary__item nav--live__item"
					>
						<button
							type="button"
							className={`nav--secondary__link ${
								sport.id == menuStore.expandedElementId
									? "is-selected"
									: ""
							}`}
							onClick={() =>
								menuStore.expandCollapseElement(sport.id)
							}
						>
							<div className="nav--secondary__icon">
								<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
									{sport.eventCount}
								</span>

								<OfferIcon
									type="sport"
									sport={sport.abrv}
									className="nav--secondary__icon__inner u-icon u-icon--lrg"
								/>
							</div>

							<div className="nav--secondary__title">
								{sport.name}
							</div>
						</button>
					</li>
				))}
			</>
		);
	}
);
